import { FC, useRef } from 'react';
import { useLogging } from '../hooks/common/useLogging';
import { useEmitResetWindow } from '../hooks/common/useEmitResetWindow';
import { SectionTitle } from '../components/common/SectionTitle';
import { InformationBox } from '../components/common/InformationBox';
import { NavigationWrapper } from '../components/common/NavigationWrapper';
import { Button } from '../components/common/Button';

export const PaymentMethodComplete: FC = () => {

  const rootElementReference = useRef<HTMLDivElement | null>(null);
  useEmitResetWindow(rootElementReference, []);

  useLogging('PaymentMethodComplete');

  return (
    <div 
      className={`appContainer paymentMethodComplete`}
      ref={rootElementReference}
    >
      <SectionTitle>お支払い方法の確認・変更</SectionTitle>
      <InformationBox title="お支払い用クレジットカード変更の受付をいたしました。">
        <p>
        ご登録いただいているメールアドレスに、決済方法変更用のURLを送付いたしました。<br/>
        お手数ですが、そちらからご変更をお願いします。
        </p>
      </InformationBox>
      <NavigationWrapper>
        <Button internalLink={'/'} type="secondary">もどる</Button>
      </NavigationWrapper>
    </div>
  );
}